import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { sanitizeReturnUrl } from '../_helpers/return-url';
import { UserAuthService } from '../_services/user-auth.service';

export const AuthGuardGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  const auth = inject(UserAuthService);
  if (auth.isUserLoggedIn()) {
    return true;
  }
  // Returning a UrlTree cancels the navigation and carries the requested url along, so the user
  // can be sent back to it once logged in.
  const returnUrl = sanitizeReturnUrl(state.url);
  return router.createUrlTree(
    ['/login'],
    returnUrl ? { queryParams: { returnUrl } } : {}
  );
};

export const checkAdminRoleGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree | Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const userService = inject(UserAuthService);
  const toasterService = inject(ToastrService);

  const auth = JSON.parse(localStorage.getItem('user') || '{}');
  if (!auth.token) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }
  if (auth.type === 'ADMIN') {
    return true;
  }

  const roleId = route.data['roleId'];
  // roleId-0 routes (/dashboard) are open to every authenticated back-office user.
  if (roleId === 0) {
    return true;
  }

  return userService.getAdminByID().pipe(
    map((data: any) => {
      const roles: unknown[] = data?.data?.roleId ?? [];
      if (roles.includes(roleId)) {
        return true;
      }
      toasterService.error(
        $localize`Vous n'avez pas la permission d'accéder à cette ressource`,
        ''
      );
      return router.createUrlTree(['/dashboard']);
    }),
    catchError(() => of(router.createUrlTree(['/dashboard'])))
  );
};
